"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRegistryQuickLinks = exports.getRegistrySecondaryNavItems = void 0;

require("core-js/modules/es.array.concat.js");

var _navConstants = require("../constants/navConstants");

var _insertInArrayIf = _interopRequireDefault(require("../util/insertInArrayIf"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getRegistrySecondaryNavItems = function getRegistrySecondaryNavItems() {
  return [{
    id: _navConstants.SecondaryNavIdentifier.REGISTRY_OVERVIEW,
    identifier: _navConstants.SecondaryNavIdentifier.REGISTRY_OVERVIEW,
    // identifier has been deprecated
    title: 'Overview',
    path: '/registry/overview',
    parent: _navConstants.PrimaryNavIdentifier.REGISTRY
  }, {
    id: _navConstants.SecondaryNavIdentifier.MANAGE_REGISTRY,
    identifier: _navConstants.SecondaryNavIdentifier.MANAGE_REGISTRY,
    title: 'Manage registry',
    path: '/my-registry',
    parent: _navConstants.PrimaryNavIdentifier.REGISTRY
  }, {
    id: _navConstants.SecondaryNavIdentifier.CHECKLIST,
    identifier: _navConstants.SecondaryNavIdentifier.CHECKLIST,
    title: 'Checklist',
    path: '/registry/checklist',
    parent: _navConstants.PrimaryNavIdentifier.REGISTRY
  }, {
    id: _navConstants.SecondaryNavIdentifier.GIFT_TRACKER,
    identifier: _navConstants.SecondaryNavIdentifier.GIFT_TRACKER,
    title: 'Gift tracker',
    path: '/registry/gift-tracker',
    parent: _navConstants.PrimaryNavIdentifier.REGISTRY
  }, {
    id: 'registry-more',
    parent: _navConstants.PrimaryNavIdentifier.REGISTRY,
    path: '',
    title: 'More'
  }];
};

exports.getRegistrySecondaryNavItems = getRegistrySecondaryNavItems;

var getRegistryQuickLinks = function getRegistryQuickLinks(registrySlug) {
  var aboutRegistry = {
    id: 'about-registry',
    identifier: 'about-registry',
    title: 'About registry',
    path: '/my-registry',
    showCaret: true,
    parent: _navConstants.PrimaryNavIdentifier.REGISTRY,
    children: [{
      id: 'registry-perks',
      identifier: 'registry-perks',
      title: 'Perks',
      path: '/wedding-registry/perks',
      parent: _navConstants.PrimaryNavIdentifier.REGISTRY
    }, {
      id: 'registry-benefits',
      identifier: 'registry-benefits',
      title: 'Why Zola registry',
      path: '/wedding-registry/benefits',
      parent: _navConstants.PrimaryNavIdentifier.REGISTRY
    }, {
      id: 'how-zola-registry-works',
      identifier: 'how-zola-registry-works',
      title: 'How it works',
      path: '/wedding-registry/how-it-works',
      parent: _navConstants.PrimaryNavIdentifier.REGISTRY
    }]
  };
  var settings = {
    id: 'account-settings',
    identifier: 'account-settings',
    title: 'Settings',
    path: '/account/settings/info',
    parent: _navConstants.PrimaryNavIdentifier.REGISTRY
  };
  var previewRegistryPath = "/registry/".concat(registrySlug, "/?preview=true");
  var preview = {
    id: 'preview-registry-dropdown',
    identifier: 'preview-registry-dropdown',
    title: 'Preview',
    showCaret: true,
    path: "".concat(previewRegistryPath),
    parent: _navConstants.PrimaryNavIdentifier.REGISTRY,
    children: [{
      id: 'preview',
      identifier: 'preview',
      title: 'Preview as guest',
      path: "".concat(previewRegistryPath),
      parent: _navConstants.PrimaryNavIdentifier.REGISTRY
    }, {
      id: 'copy-registry-link',
      identifier: 'copy-registry-link',
      title: 'Copy link',
      path: "".concat(previewRegistryPath),
      parent: _navConstants.PrimaryNavIdentifier.REGISTRY
    }]
  };
  return [].concat(_toConsumableArray((0, _insertInArrayIf.default)(!!registrySlug, preview)), [aboutRegistry, settings]);
};

exports.getRegistryQuickLinks = getRegistryQuickLinks;